import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';

import { Observable } from 'rxjs';

import { ElementActions, ElementTypes, GaContext } from '@fcom/common';
import { TabTheme, TabLayoutType } from '@fcom/ui-components';
import { SortBy } from '@fcom/common-booking/interfaces';
import { GtmService } from '@fcom/common/gtm';

@Component({
  selector: 'fin-flight-selection-sort-by',
  styleUrls: ['./flight-selection-sort-by.component.scss'],
  templateUrl: './flight-selection-sort-by.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightSelectionSortByComponent implements OnChanges {
  @Input()
  currencyCode: string;

  @Input()
  showPoints = false;

  @Input()
  resultsAmount: number;

  @Input()
  bestFlightPrice: string;

  @Input()
  fastestFlightPrice: string;

  @Input()
  lowestPrice: string;

  @Input()
  selectedSortBy$: Observable<SortBy>;

  @Input()
  isMobile$: Observable<boolean>;

  @Input()
  showBestFlightsTab = true;

  @Output()
  sortByChange: EventEmitter<SortBy> = new EventEmitter();

  shouldShowTabSubtitle = false;
  modalOpen = false;

  readonly TabTheme = TabTheme;
  readonly TabLayoutType = TabLayoutType;
  readonly SortBy = SortBy;

  constructor(private gtmService: GtmService) {}

  ngOnChanges(): void {
    this.shouldShowTabSubtitle = this.resultsAmount !== 0;
  }

  onSortChangeFromTabs(event: { index: number; data: unknown }): void {
    this.gtmService.trackElement(
      `booking-flow-sort-change-${event.data}`,
      GaContext.BOOKING_FLOW,
      ElementTypes.TAB,
      undefined,
      ElementActions.CLICK
    );
    this.sortByChange.emit(event.data as SortBy);
  }

  onSortChangeFromModal(sortBy: SortBy): void {
    this.gtmService.trackElement(
      `booking-flow-sort-change-${sortBy}`,
      GaContext.BOOKING_FLOW,
      ElementTypes.MODAL,
      undefined,
      ElementActions.CLICK
    );

    this.sortByChange.emit(sortBy);
  }

  openSortingModal(): void {
    this.modalOpen = true;
  }

  closeSortingModal(): void {
    this.modalOpen = false;
  }
}
